import { render, staticRenderFns } from "./RightBox_2.vue?vue&type=template&id=393691fd&scoped=true&"
import script from "./RightBox_2.vue?vue&type=script&lang=js&"
export * from "./RightBox_2.vue?vue&type=script&lang=js&"
import style0 from "./RightBox_2.vue?vue&type=style&index=0&id=393691fd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393691fd",
  null
  
)

export default component.exports